import React from 'react';
import PropTypes from 'prop-types';

import { helpUrl } from '@Constants/CommonConstants';
import { ProjectStatus, ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';
import { ButtonWithIcon } from '@els/els-react--button';
import classnames from 'classnames';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import { LinkElement } from '@els/els-react--link-element';

function DialogMessage({ status }) {
  switch (status) {
    case ProjectStatus.ERROR_RETRY:
      return (
        <>
          Reaxys was unable to process this synthesis job request. Please try submitting the synthesis job again. If the problem persists,
          please contact &nbsp;
          <LinkElement
            href={helpUrl}
            isExternal
            noExternalIcon
            inline
            iconSprite="ChevronRight"
            className="e2e-contact-customer-care"
            iconRight>
            Customer Care
          </LinkElement>
        </>
      );
    case ProjectStatus.FATAL_ERROR:
    default:
      return (
        <>
          Reaxys was unable to process this synthesis job request. If the problem persists, please contact &nbsp;
          <LinkElement
            href={helpUrl}
            isExternal
            noExternalIcon
            inline
            iconSprite="ChevronRight"
            className="e2e-contact-customer-care"
            iconRight>
            Customer Care
          </LinkElement>
        </>
      );
  }
}

function SynthesisJobRetryDialog({ project, status, type, onRetry = () => null, ...dialogProps }) {
  const { footerClassName, onYesClick, selfClose } = dialogProps;
  return (
    <DialogsWithIcon
      {...dialogProps}
      size="md"
      character="!"
      header="Processing error"
      layoutType="info"
      headerClassName="dialog-with-info-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-info-layout-footer-wrapper')}
      footer={
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        <div className="els-btn-group-right" tabIndex={0}>
          {status === ProjectStatus.ERROR_RETRY && (
            <ButtonWithIcon
              type="primary"
              size="small"
              sprite="ChevronRight"
              linkIconSize="s"
              iconRight
              onClick={() => {
                onRetry(project.id, type);
                selfClose();
              }}
              className="e2e-dialog-retry">
              Retry
            </ButtonWithIcon>
          )}
          <ButtonWithIcon
            type="primary"
            size="small"
            sprite="ChevronRight"
            linkIconSize="s"
            iconRight
            onClick={onYesClick || selfClose}
            className="e2e-dialog-ok">
            OK
          </ButtonWithIcon>
        </div>
      }>
      <DialogMessage status={status} />
    </DialogsWithIcon>
  );
}

SynthesisJobRetryDialog.propTypes = {
  project: PropTypes.object,
  status: PropTypes.oneOf(ProjectStatus.allTypes),
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
  onRetry: PropTypes.func,
};

export default SynthesisJobRetryDialog;
